import React from "react";
import { AspectRatio, Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import Image from "next/legacy/image";
import { Section, sectionSpacingY } from "components/section";
import { Bullets } from "components/bullets";
import beforeHT from "../../../../public/assets/integrations/before-ht.svg";
import afterHT from "../../../../public/assets/integrations/after-ht.svg";

export function BeforeAfterHightouch() {
  return (
    <Section my="0" py={sectionSpacingY}>
      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        width="100%"
        justifyItems="left"
        alignItems="baseline"
        gap={{ base: "small", md: 0 }}
      >
        <Flex
          as="figure"
          direction="column"
          align={{ base: "start", md: "center" }}
          w="100%"
          pr={{ md: "biggest" }}
          borderRight={{ md: "1px" }}
          borderColor="brand.border.light"
          mx="auto"
        >
          <AspectRatio ratio={1 / 1} w="100%" maxW={{ base: "250px", md: "400px" }}>
            <Image
              src={beforeHT.src}
              alt="Chaotic graph of interconnected nodes representing data warehouses, data, and business tools."
              layout="fill"
              objectFit="contain"
            />
          </AspectRatio>
          <Box as="figcaption" mt={12}>
            <Text textStyle="headline2">Before Hightouch</Text>
            <Bullets
              mt={3}
              fontSize="brand.md"
              items={["Inconsistent and inaccurate data", "Laborious and expensive", "Brittle and inflexible"]}
            />
          </Box>
        </Flex>

        <Flex
          as="figure"
          direction="column"
          align={{ base: "start", md: "center" }}
          w="100%"
          mx="auto"
          pl={{ md: "biggest" }}
        >
          <AspectRatio ratio={1 / 1} w="100%" maxW={{ base: "250px", md: "400px" }}>
            <Image
              src={afterHT.src}
              alt="Clean and easily readable graph of data moving from a warehouse node, to Hightouch, to business tools."
              layout="fill"
              objectFit="contain"
            />
          </AspectRatio>
          <Box as="figcaption" mt={12}>
            <Text textStyle="headline2">After Hightouch</Text>
            <Bullets
              mt={3}
              fontSize="brand.md"
              items={["Consistent and accurate", "Observable and governed", "Scalable and flexible"]}
            />
          </Box>
        </Flex>
      </SimpleGrid>
    </Section>
  );
}
